import React, { useContext, useEffect, useState } from 'react'
import useWindowSize from '../../customHooks/useWindowSize';
import { CustomModal } from '../CustomModal/CustomModal';
import { t } from 'i18next';
import { CustomRange } from '../CustomRange/CustomRange';
import { CustomSelectComplex } from '../CustomSelectComplex/CustomSelectComplex';
import AccessOpeningContext from '../../context/AccessOpeningContext/AccessOpeningContext';
import { Spinner } from 'reactstrap';
import ButtonGroupGrayCustom from '../Buttons/ButtonGroupGrayCustom';
import ContractorsContext from '../../context/ContractorsContext/ContractorsContext';
import ButtonBlackReturn from '../Buttons/ButtonBlackReturn';
import { ButtonBlue } from '../Buttons/ButtonBlue';
import EntryAndDepartureReportContext from '../../context/EntryAndDepartureReportContext/EntryAndDepartureReportContext';
import AccessHoursContext from '../../context/AccessHoursContext/AccessHoursContext';
import { getDataUserByKey, getTenantInfoByKey, getUserBuilding, getUserOpening } from '../../helpers/helpers';
import AccessBuildingContext from '../../context/AccessBuildingContext/AccessBuildingContext';
import AccessAreaContext from '../../context/AccessAreaContext/AccessAreaContext';

export const EntryAndDepartureFilterModal = ({ showModal, setShowModal }) => {
    const { windowWidth } = useWindowSize();

    const fullscreen = windowWidth <= 576

    const profile_id = getDataUserByKey('access_profile_id');
    const isGuard = Number(profile_id) === 3;

    const { accessOpeningState, getAccessOpenings } = useContext(AccessOpeningContext);
    const { accessOpenigs } = accessOpeningState;

    const { accessHoursState, getAccessHours } = useContext(AccessHoursContext);
    const { accessHours } = accessHoursState;

    const { getContractors, contractorsState } = useContext(ContractorsContext);
    const { contractors } = contractorsState;

    const { getAccessBuildings, accessBuildingState } = useContext(AccessBuildingContext);
    const { accessBuildings } = accessBuildingState;

    const { accessAreaState, getAccessAreas } = useContext(AccessAreaContext);
    const { accessAreas } = accessAreaState;

    const { entryAndDepartureReportState, getEntriesAndDepartures } = useContext(EntryAndDepartureReportContext);
    const { filters } = entryAndDepartureReportState;

    const [filtersState, setFiltersState] = useState(filters);

    const contractorsFilters = filtersState.contractors;

    const contractorsOptions = contractors.map(contractor => ({ label: `${contractor.contractor_name} - ${contractor.contractor_natural_id}`, value: contractor.contractor_id }));
    const accessBuildingsOptions = accessBuildings.map(accessBuilding => ({ label: `${accessBuilding.opening ? accessBuilding.opening.openingDescription + ' - ' : ''}${accessBuilding.buildingDescription} - ${accessBuilding.buildingCode}`, value: accessBuilding.buildingId }));
    const accessAreasOptions = [{
        label: t('FREE_ACCESS_AREA'),
        value: null,
    }].concat(accessAreas.map(accessArea => ({ label: `${accessArea.Building.buildingDescription} - ${accessArea.code} ${accessArea.description}`, value: accessArea.area_id })));


    const haveAccessOpenings = isGuard ? getUserOpening().descripcion !== t('NO_OPENING') : getTenantInfoByKey('is_access_opening');

    const haveAccessBuildings = isGuard ? getUserBuilding().buildingDescription !== t('NO_BUILDING') : getTenantInfoByKey('is_building');

    const haveSelectedAnOpening = filtersState.opening_code.length > 0;

    const showAreasSelect = isGuard ? haveAccessBuildings : filtersState.buildings.length > 0;

    const showBuildingsSelect = haveAccessOpenings === true ? (haveAccessBuildings === true && haveSelectedAnOpening === true) : haveAccessBuildings === true;

    const handleChangeSelector = (name, value) => {
        setFiltersState({ ...filtersState, [name]: value })
    }

    const handleSetOpening = (newOpening) => {
        const wasAdded = filtersState.opening_code.some(openigSelected => openigSelected === newOpening);
        if (wasAdded) {
            setFiltersState({
                ...filtersState,
                opening_code: filtersState.opening_code.filter(openigSelected => openigSelected !== newOpening),
                buildings: [],
                areas: []
            })
        } else {
            setFiltersState({
                ...filtersState,
                opening_code: [...filtersState.opening_code, newOpening],
                buildings: [],
                areas: []
            })
        }
    };

    const handleSetBuildings = (value) => {
        setFiltersState({ ...filtersState, buildings: value, areas: [] })
    }
    const accessOpenigsOptions = accessOpenigs.map(accessOpenig => ({
        title: accessOpenig.descripcion,
        active: filtersState.opening_code.includes(accessOpenig.codigo),
        onClick: () => handleSetOpening(accessOpenig.codigo)
    }));

    const hoursValues = accessHours.map((item, i) => {
        return { number: item.hour === '+24' ? null : Number(item.hour), range: i + 1, description: item.hour }
    })

    const [hour, setHour] = useState({ minRange: filtersState.permanence_time_from, minNumber: filtersState.permanence_time_from, maxRange: filtersState.permanence_time_to, maxNumber: filtersState.permanence_time_to });

    const refreshHour = () => {
        const { permanence_time_from, permanence_time_to } = filters;
        if (hoursValues.length) {
            const timeFromRange = hoursValues.find((op) => op.number === permanence_time_from).range;
            const timeToRange = hoursValues.find((op) => op.number === permanence_time_to).range;
            return setHour({ minRange: timeFromRange, minNumber: permanence_time_from, maxRange: timeToRange, maxNumber: permanence_time_to });
        }

        getAccessHours();
    }

    const handleSubmitFilter = () => {
        getEntriesAndDepartures({ ...filtersState, reg_from: 1, search_text: '', });
        setShowModal(!showModal);
    }

    const cleanFiltersInModal = () => {
        setFiltersState({
            ...filters,
            permanence_time_from: 0,
            permanence_time_to: null,
            contractors: [],
            opening_code: [],
            buildings: []
        })
    }

    useEffect(() => {
        if (showModal === true) {
            getContractors();
            refreshHour();
            if (haveAccessOpenings === true && isGuard === false) {
                getAccessOpenings(true);
            }
            if (showBuildingsSelect && isGuard === false) {
                getAccessBuildings(true, filtersState.opening_code);
            }
            if (showAreasSelect) {
                const buildings = isGuard ? [getUserBuilding().buildingId] : filtersState.buildings;
                getAccessAreas(buildings)
            }
        }
        // eslint-disable-next-line
    }, [showModal, filtersState.opening_code, filtersState.buildings]);

    useEffect(() => {
        setHour({ minRange: 1, minNumber: hoursValues[0]?.number, maxRange: hoursValues.length, maxNumber: hoursValues[hoursValues.length - 1]?.number });
        // eslint-disable-next-line
    }, [accessHours]);

    useEffect(() => {
        setFiltersState({ ...filtersState, permanence_time_from: hour.minNumber, permanence_time_to: hour.maxNumber })
        // eslint-disable-next-line
    }, [hour]);

    return (
        <CustomModal
            showModal={showModal}
            setShowModal={() => setShowModal(!showModal)}
            fullscreen={fullscreen}
            backgroundColor='var(--gray-50)'
        >
            <div>
                <div className='row'>
                    {
                        fullscreen ?
                            <div className="col d-flex justify-content-start">
                                <i
                                    type='button'
                                    onClick={() => setShowModal(!showModal)}
                                    className="fa-solid fa-arrow-left fs-3"
                                >
                                </i>
                            </div>
                            :
                            null
                    }
                    <div className="col">
                        <h5 className={`m-0 gray-950-color text-${fullscreen ? 'center' : 'start'}`}>
                            {t('FILTERS')}
                        </h5>
                    </div>
                    <div className="col d-flex justify-content-end">
                        {
                            fullscreen ?
                                null
                                :
                                <i
                                    type='button'
                                    onClick={() => setShowModal(!showModal)}
                                    className="fa-solid fa-xmark fs-3"
                                >
                                </i>
                        }
                    </div>
                </div>

                <div className="col mb-3">
                    <label
                        className="form-label titlelabel-filter"
                        htmlFor="contractors"
                    >
                        {t('CONT')}
                    </label>

                    <CustomSelectComplex
                        options={contractorsOptions}
                        /* value={contractorsOptions.filter((cont) => contcont.value)} */
                        value={contractorsOptions.filter((op) => contractorsFilters.find((cont) => cont === op.value))}
                        name={'contractors'}
                        isMulti={true}
                        placeholder={t('SELECT')}
                        isClearable={true}
                        onChange={(options) => handleChangeSelector('contractors', options.map(option => option.value))}
                    />
                </div>
                {(haveAccessOpenings === true && isGuard === false) && (
                    <div className='col col-md-9 col-sm-8 d-flex align-items-sm-center gap-3 flex-sm-row flex-column'>
                        <span className='titlelabel-filter'>
                            {t('OPENINGS')}
                        </span>
                        {
                            accessOpeningState.isFetching ?
                                <Spinner />
                                :
                                <ButtonGroupGrayCustom options={accessOpenigsOptions} />
                        }
                    </div>
                )}

                {(showBuildingsSelect && isGuard === false) && (
                    <div className="col">
                        <label
                            className="form-label blue-dark-text-two fw-semibold"
                            htmlFor="buildings"
                        >
                            {getTenantInfoByKey('building_name')}
                        </label>
                        <CustomSelectComplex
                            options={accessBuildingsOptions}
                            name={'buildings'}
                            placeholder={t('SELECT')}
                            isClearable={true}
                            isMulti
                            value={accessBuildingsOptions.filter(accessBuildingsOption => filtersState.buildings.some(building => building === accessBuildingsOption.value))}
                            onChange={(options) => handleSetBuildings(options.map(option => option.value))}
                        />
                    </div>
                )}


                {(showAreasSelect) && (
                    <div className="col">
                        <label
                            className="form-label blue-dark-text-two fw-semibold"
                            htmlFor="areas"
                        >
                            {getTenantInfoByKey('area_name')}
                        </label>
                        <CustomSelectComplex
                            options={accessAreasOptions}
                            name={'areas'}
                            placeholder={t('SELECT')}
                            isClearable={true}
                            isMulti
                            value={accessAreasOptions.filter(accessAreas => filtersState.areas.some(areas => areas === accessAreas.value))}
                            onChange={(options) => handleChangeSelector('areas', options.map(option => option.value))}
                        />
                    </div>
                )}

                <div className='mt-2'>
                    <p className='mb-2 titlelabel-filter'>
                        {t('PERMANENCE_TIME')}
                    </p>

                    {hoursValues.length > 0 ?
                        <CustomRange
                            values={hoursValues}
                            showLegend={true}
                            max={hoursValues.length}
                            value={hour}
                            onChange={setHour}
                        />
                        :
                        <Spinner />
                    }

                    <p style={{ fontSize: '14px', fontWeight: '600' }}>
                        {`${t('HOURS')}: ${hour.minNumber} - ${hour.maxNumber === null ? '+24' : hour.maxNumber}`}
                    </p>
                </div>

                {fullscreen ?
                    <div className='d-flex justify-content-between align-items-center mb-4 ps-3 pe-3' style={{ position: 'fixed', bottom: '0', left: '0', width: '100%' }}>
                        <div className="w-75">
                            <ButtonBlackReturn title={t('ERASE')} /* onClick={handleGetBack} */ />
                        </div>
                        <div className="w-50">
                            <ButtonBlue className='w-100' onClick={handleSubmitFilter} /* disabled={disabled()} */>
                                {t('APPLY')}
                            </ButtonBlue>
                        </div>
                    </div>
                    :
                    <div className='d-flex justify-content-end align-items-center mb-4 ps-3 pe-3'>
                        <div className="me-3">
                            <p className='m-0 btn gray-900-bg white-color w-100 me-3 ms-3 ' type={'button'} onClick={cleanFiltersInModal}>{t('ERASE')}</p>
                        </div>
                        <div className="">
                            <ButtonBlue className='w-100 me-3 ms-3' onClick={handleSubmitFilter} /* disabled={disabled()} */>
                                {t('APPLY')}
                            </ButtonBlue>
                        </div>
                    </div>
                }

            </div>
        </CustomModal>
    )
}
